import { API, graphqlOperation } from "aws-amplify";
import { createModeratorChatTokenLf } from "graphql/mutations";
import { CreateChatTokenInput, Response } from "types/graphqlapi";

export const createModeratorChatTokenIdQuery = async (
  input: CreateChatTokenInput
): Promise<void> => {
  (await API.graphql(
    graphqlOperation(createModeratorChatTokenLf, {
      input,
    })
  )) as {
    data: { createModeratorChatTokenLf: Response };
  };
};
